import React from 'react';
import PropTypes from 'prop-types';

const AdaptivePicture = ({
  img, srcset, alt, styles,
}) => (
  <picture>
    <source srcSet={srcset.map(({ src, size }) => size ? `${src} ${size}` : src).join(', ')} />
    <img src={`${img}`} alt={alt} style={styles} />
  </picture>
);

AdaptivePicture.propTypes = {
  img: PropTypes.string.isRequired,
  srcset: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.string,
    size: PropTypes.string,
  })).isRequired,
  alt: PropTypes.string,
  styles: PropTypes.object,
};

AdaptivePicture.defaultProps = {
  alt: '',
  styles: {},
};

export { AdaptivePicture };
